export const AI_VIDEO_GENERATOR_GENERATE_STATE = {
  PENDING: 'PENDING',
  DOWNLOADED: 'DOWNLOADED',
  PROJECT_CREATING: 'PROJECT_CREATING',
  PROJECT_CREATED: 'PROJECT_CREATED',
  ERROR: 'ERROR',
} as const

export type AiVideoGeneratorGenerateState =
  keyof typeof AI_VIDEO_GENERATOR_GENERATE_STATE

export const MAX_FREE_TRIAL_COUNT = 0
